import CustomBtn from "components/fragments/CustomBtn";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { authHandler } from "../redux/handlers";
import { useDispatch } from "react-redux";
import { useSocketLogout } from "../hooks/useSocketLogout";
import socketService from "../services/socketService";
import LogoutConfirmModal from "../components/modals/LogoutConfirmModal";
import { setBranch } from "../redux/slices/pos.slice";

export default function BranchSelector() {
  useSocketLogout();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [branchList, setBranchList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        setLoading(true);
        setError(null);
        const branchResponse = await dispatch(
          authHandler.getUserBranch(businessSlug)
        );
        if (!branchResponse || branchResponse.length === 0) {
          setError("ไม่พบข้อมูลสาขาสำหรับบัญชีนี้ กรุณาติดต่อผู้ดูแลระบบ");
        } else {
          setBranchList(branchResponse);

          if (branchResponse.length === 1) {
            dispatch(setBranch(branchResponse[0]));
            navigate(`/${businessSlug}/verify-pin`);
          }
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูลสาขา กรุณาลองใหม่อีกครั้ง");
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, [businessSlug, dispatch, navigate]);

  const handleSelectBranch = (branch) => {
    dispatch(setBranch(branch));
    navigate(`/${businessSlug}/verify-pin`);
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleConfirmLogout = async () => {
    setShowLogoutModal(false);
    localStorage.removeItem("email");
    localStorage.removeItem("branchId");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("branchKitchenId");
    localStorage.removeItem("branchPOSId");
    socketService.disconnect();
    await dispatch(authHandler.logout(businessSlug));
    navigate(`/${businessSlug}/login`, { replace: true });
  };

  return (
    <div className="login-bg w-full min-h-screen flex justify-center items-center sarabun text-[var(--color-black)] p-[1vw]">
      <div className="bg-white p-[min(2.92vw,30px)] flex flex-col items-center rounded-[min(2.44vw,25px)] w-[min(39.16vw,401px)]">
        <div className="bg-white w-[min(38.67vw,396px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-18 text-[var(--color-black-2)] text-center leading-[1.8] font-[700]">
          <div className="text-24 font-[700] flex flex-col items-center">
            <div className="w-[min(4.83vw,49.5px)] aspect-square">
              <img
                className="w-full h-full object-contain"
                src="/img/logo-3.png"
                alt=""
              />
            </div>
            <div className="comfortaa">
              <span className="text-[--color-grey]">Allder</span>{" "}
              <span className="text-[--color-green]">Cafe'</span>
            </div>
          </div>
          <div className={"mt-[min(1.46vw,15px)] mb-10"}>
            {loading ? (
              <div className="flex justify-center items-center h-[260px]">
                <div className="text-center">กำลังโหลดข้อมูล...</div>
              </div>
            ) : error ? (
              <div className="flex justify-center items-center h-[260px]">
                <div className="text-center text-red-500">{error}</div>
              </div>
            ) : branchList?.length === 0 ? (
              <div className="flex justify-center items-center h-[260px]">
                <div className="text-center">
                  ไม่พบข้อมูลสาขา กรุณาติดต่อผู้ดูแลระบบ
                </div>
              </div>
            ) : (
              <div className="overflow-auto h-[260px]">
                <div className="pr-3 pb-7">
                  {branchList?.map((branch, index) => (
                    <div
                      key={index}
                      className="border-1 drop-shadow bg-[#FFF] mb-3 cursor-pointer px-4 py-3 rounded-lg flex items-center"
                      onClick={() => handleSelectBranch(branch)}
                    >
                      <img
                        className="object-contain w-[50px] h-[50px]"
                        src={branch.branch?.image_path || "/img/logo-3.png"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/img/logo-3.png";
                        }}
                        alt=""
                      />
                      <div className="ml-3 text-left">
                        <div className="text-[#061126] font-semibold lh-1 mb-2">
                          {branch.branch?.branch_name}
                        </div>
                        <div className="text-[#061126] font-light lh-1 text-sm">
                          รหัสสาขา {branch.branch?.code} (
                          {branch.branch?.vat_code || "-"})
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="gap-[min(2.01vw,20.63px)] w-full mt-[min(2.44vw,35px)]">
            <CustomBtn
              onClick={handleLogoutClick}
              className={`leading-[0.8] !bg-[#F95057] w-full min-w-[min(10.25vw,105px)] text-18 !text-[#FFF] font-[600] !min-h-[50px] rounded-[min(0.78vw,8px)]`}
              btntxt={"ออกจากระบบ"}
            />
          </div>

          <div className="mt-[min(3.22vw,30px)] mx-auto justify-center text-16 flex gap-[min(0.87vw,9px)]">
            <div>Power By</div>
            <div className="aspect-square w-[min(2.05vw,21px)]">
              <img
                className="w-full h-full object-contain"
                src="/img/logo_allder_2-01.png"
                alt=""
              />
            </div>
            <div>Allder</div>
          </div>
        </div>
      </div>

      <LogoutConfirmModal
        isOpen={showLogoutModal}
        onClose={handleCancelLogout}
        onConfirm={handleConfirmLogout}
      />
    </div>
  );
}
